import { render, staticRenderFns } from "./SupportTicketsMenu.vue?vue&type=template&id=70659048&scoped=true"
import script from "./SupportTicketsMenu.vue?vue&type=script&lang=js"
export * from "./SupportTicketsMenu.vue?vue&type=script&lang=js"
import style0 from "./SupportTicketsMenu.vue?vue&type=style&index=0&id=70659048&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70659048",
  null
  
)

export default component.exports